module.exports = __webpack_public_path__ + "img/18.5.COD.5c7f094e.png";